import { Navigate, useRoutes } from 'react-router-dom';
import Cookies from 'universal-cookie';

import UserPage from './pages/users/UserPage';
import TeacherPage from './pages/teacher/TeacherPage';
import ClassPage from './pages/classes/ClassPage';
import TimetablePage from './pages/timetable/TimetablePage';
import TestimonialPage from './pages/testimonial/TestimonialPage';
import CoursePage from './pages/course/CoursePage';
import ContactPage from './pages/contact/ContactPage';
import ResourcePage from './pages/resource/ResourcePage';
import ChildProfilePage from './pages/child/ChildProfilePage';

import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import Dashboard from './components/Dashboard';
import NewClasses from './pages/classes/NewClass';
import NewCourse from './pages/course/NewCourse';
import NewTeacher from './pages/teacher/NewTeacher';
import NewTimetable from './pages/timetable/NewTimetable';
import NewResource from './pages/resource/NewResource';
import NewTestimonial from './pages/testimonial/NewTestimonial';
import UpdateClasses from './pages/classes/UpdateClass';
import UpdateCourse from './pages/course/UpdateCourse';
import UpdateTeacher from './pages/teacher/UpdateTeacher';
import UpdateTimetable from './pages/timetable/UpdateTimetable';
import UpdateResource from './pages/resource/UpdateResource';
import UpdateTestimonial from './pages/testimonial/UpdateTestimonial';
import UpdateUser from './pages/users/UpdateUser';
import RegisterPage from './pages/RegisterPage';
import ChildDetails from './pages/child/ChildDetails';
import ContactDetails from './pages/contact/ContactDetails';
import AddNewUser from './pages/users/AddNewUser';
import EnquiryPage from './pages/enquiry/EnquiryPage';
import NewEnquiry from './pages/enquiry/NewEnquiry';
import UpdateEnquiry from './pages/enquiry/UpdateEnquiry';
import ChangePassword from './pages/ChangePassword';
import Settings from './pages/settings/Settings';
import NewAboutUs from './pages/aboutus/NewAboutUs';
import FAQPage from './pages/FAQ/FAQPage';
import NewFAQ from './pages/FAQ/NewFAQ';
import NewFAQDetail from './pages/FAQ/NewFAQDetail';
import UpdateFAQ from './pages/FAQ/UpdateFAQ';
import JoinTeam from './pages/joinTeam/JoinTeamPage';
import GalleryPage from './pages/gallery/GalleryPage';
import NewGallery from './pages/gallery/NewGallery';
import UpdateGallery from './pages/gallery/UpdateGallery';
import Subscriber from './pages/subscriber/subscriber';
import AboutUsPage from './pages/aboutus/AboutUsPage';
import UpadateAboutUs from './pages/aboutus/UpdateAboutUs';

import PaymentHistory from './pages/Payments/PaymentHistory';

// Shop Pages
import ProductPage from './pages/products/ProductPage';
import NewProduct from './pages/products/NewProduct';
import UpdateProduct from './pages/products/UpdateProduct';
import OrderPage from './pages/orders/OrderPage';
import OrderDetails from './pages/orders/OrderDetails';

// Course Orders
import CourseOrdersPage from './pages/courseOrders/CourseOrdersPage';
import CourseOrderDetails from './pages/courseOrders/CourseOrderDetails';

// Contact enquiries (Phase 2)
import ContactEnquiriesPage from './pages/contactEnquiries/ContactEnquiriesPage';
import ContactEnquiryDetailPage from './pages/contactEnquiries/ContactEnquiryDetailPage';
import ConsultationSlotsPage from './pages/consultations/ConsultationSlotsPage';

// Portal accounts (parents/teachers/students) + subjects + emails
import ParentsPage from './pages/accounts/ParentsPage';
import ParentDetailPage from './pages/accounts/ParentDetailPage';
import PendingApprovalsPage from './pages/accounts/PendingApprovalsPage';
import StudentsPage from './pages/accounts/StudentsPage';
import StudentDetailPage from './pages/accounts/StudentDetailPage';
import TeachersAccountsPage from './pages/accounts/TeachersAccountsPage';
import TeacherDetailPage from './pages/accounts/TeacherDetailPage';
import SubjectsPage from './pages/subjects/SubjectsPage';
import LevelsPage from './pages/levels/LevelsPage';
import EmailComposerPage from './pages/emails/EmailComposerPage';
import EmailTemplatesPage from './pages/emails/EmailTemplatesPage';
import SentEmailsPage from './pages/emails/SentEmailsPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import InvoiceCreatePage from './pages/invoices/InvoiceCreatePage';
import InvoiceDetailPage from './pages/invoices/InvoiceDetailPage';
import InvoiceSchedulesPage from './pages/invoices/InvoiceSchedulesPage';
import InvoiceScheduleCreatePage from './pages/invoices/InvoiceScheduleCreatePage';
import InvoiceLineTemplatesPage from './pages/invoiceLineTemplates/InvoiceLineTemplatesPage';
import AcademicYearsPage from './pages/academicYears/AcademicYearsPage';
import TermsPage from './pages/academicYears/TermsPage';
import OptionalTopicsPage from './pages/optionalTopics/OptionalTopicsPage';
import TutoringClassesPage from './pages/tutoringClasses/TutoringClassesPage';
import TutoringClassFormPage from './pages/tutoringClasses/TutoringClassFormPage';
import ClassRegisterPage from './pages/registers/RegisterPage';
import ReportsPage from './pages/reports/ReportsPage';
import TutorPayoutsPage from './pages/tutorPayouts/TutorPayoutsPage';
import WaitingListPage from './pages/waitingList/WaitingListPage';
import MessagingPage from './pages/messaging/MessagingPage';
import CoverRequestsPage from './pages/coverRequests/CoverRequestsPage';
import RenewalsPage from './pages/renewals/RenewalsPage';

// ----------------------------------------------------------------------

const cookies = new Cookies();
const token = cookies.get('TOKEN');

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: token ? <Dashboard /> : <Navigate to="/login" />,
      children: [
        { element: <Navigate to="/class" />, index: true },
        // Shop Products
        {
          path: '/products',
          element: <ProductPage />,
        },
        {
          path: '/products/new',
          element: <NewProduct />,
        },
        {
          path: '/products/edit/:id',
          element: <UpdateProduct />,
        },
        // Shop Orders
        {
          path: '/orders',
          element: <OrderPage />,
        },
        {
          path: '/orders/:id',
          element: <OrderDetails />,
        },
        // Course Orders
        {
          path: '/course-orders',
          element: <CourseOrdersPage />,
        },
        {
          path: '/course-orders/:id',
          element: <CourseOrderDetails />,
        },
        {
          path: '/user',
          element: <UserPage />,
        },
        {
          path: '/user/newUser',
          element: <AddNewUser />,
        },
        {
          path: '/user/updateUser/:id',
          element: <UpdateUser />,
        },
        {
          path: '/changePassword',
          element: <ChangePassword />,
        },
        {
          path: '/enquiry',
          element: <EnquiryPage />,
        },
        {
          path: '/enquiry/newEnquiry',
          element: <NewEnquiry />,
        },
        {
          path: '/enquiry/updateEnquiry/:id',
          element: <UpdateEnquiry />,
        },
        {
          path: '/teacher',
          element: <TeacherPage />,
        },
        {
          path: '/teacher/newTeacher',
          element: <NewTeacher />,
        },
        {
          path: '/teacher/updateTeacher/:id',
          element: <UpdateTeacher />,
        },
        {
          path: '/class',
          element: <ClassPage />,
        },
        {
          path: '/class/newClass',
          element: <NewClasses />,
        },

        {
          path: '/class/updateClass/:id',
          element: <UpdateClasses />,
        },
        {
          path: '/course',
          element: <CoursePage />,
        },
        {
          path: '/course/newCourse',
          element: <NewCourse />,
        },
        {
          path: '/course/updateCourse/:id',
          element: <UpdateCourse />,
        },
        {
          path: '/contact',
          element: <ContactPage />,
        },
        {
          path: '/contact/details/:id',
          element: <ContactDetails />,
        },
        {
          path: '/childprofile',
          element: <ChildProfilePage />,
        },
        {
          path: '/childprofile/details/:id',
          element: <ChildDetails />,
        },
        {
          path: '/join-team',
          element: <JoinTeam />,
        },
        {
          path: '/subscriber',
          element: <Subscriber />,
        },
        {
          path: '/resource',
          element: <ResourcePage />,
        },
        {
          path: '/resource/newResource',
          element: <NewResource />,
        },
        {
          path: '/resource/updateResource/:id',
          element: <UpdateResource />,
        },
        {
          path: '/timetable',
          element: <TimetablePage />,
        },
        {
          path: '/timetable/newTimetable',
          element: <NewTimetable />,
        },
        {
          path: '/timetable/updateTimetable/:id',
          element: <UpdateTimetable />,
        },
        {
          path: '/testimonial',
          element: <TestimonialPage />,
        },
        {
          path: '/testimonial/newTestimonial',
          element: <NewTestimonial />,
        },
        {
          path: '/testimonial/updateTestimonial/:id',
          element: <UpdateTestimonial />,
        },

        {
          path: '/settings',
          element: <Settings />,
        },
        {
          path: '/about-us/new-bout-us',
          element: <NewAboutUs />,
        },
        {
          path: '/about-us',
          element: <AboutUsPage />,
        },
        {
          path: '/about-us/about-us-update/:id',
          element: <UpadateAboutUs />,
        },
        {
          path: '/FAQ',
          element: <FAQPage />,
        },
        {
          path: '/FAQ/newFAQ',
          element: <NewFAQ />,
        },
        {
          path: '/FAQ/updateFAQ/:id',
          element: <UpdateFAQ />,
        },
        {
          path: '/FAQ/newFAQDetail',
          element: <NewFAQDetail />,
        },
        {
          path: '/gallery',
          element: <GalleryPage />,
        },
        {
          path: '/gallery/new-gallery',
          element: <NewGallery />,
        },

        {
          path: '/gallery/update-gallery/:id',
          element: <UpdateGallery />,
        },
        {
          path: '/payment-history',
          element: <PaymentHistory />,
        },
        {
          path: '/accounts/pending',
          element: <PendingApprovalsPage />,
        },
        {
          path: '/parents',
          element: <ParentsPage />,
        },
        {
          path: '/parents/:id',
          element: <ParentDetailPage />,
        },
        {
          path: '/students',
          element: <StudentsPage />,
        },
        {
          path: '/students/:id',
          element: <StudentDetailPage />,
        },
        {
          path: '/teacher-accounts',
          element: <TeachersAccountsPage />,
        },
        {
          path: '/teacher-accounts/:id',
          element: <TeacherDetailPage />,
        },
        {
          path: '/subjects',
          element: <SubjectsPage />,
        },
        {
          path: '/levels',
          element: <LevelsPage />,
        },
        {
          path: '/emails',
          element: <EmailComposerPage />,
        },
        {
          path: '/email-templates',
          element: <EmailTemplatesPage />,
        },
        {
          path: '/emails-sent',
          element: <SentEmailsPage />,
        },
        {
          path: '/invoices',
          element: <InvoicesPage />,
        },
        {
          path: '/invoices/new',
          element: <InvoiceCreatePage />,
        },
        {
          path: '/invoices/:id',
          element: <InvoiceDetailPage />,
        },
        {
          path: '/invoice-schedules',
          element: <InvoiceSchedulesPage />,
        },
        {
          path: '/invoice-schedules/new',
          element: <InvoiceScheduleCreatePage />,
        },
        {
          path: '/invoice-descriptions',
          element: <InvoiceLineTemplatesPage />,
        },
        {
          path: '/academic-years',
          element: <AcademicYearsPage />,
        },
        {
          path: '/academic-years/:yearId/terms',
          element: <TermsPage />,
        },
        {
          path: '/optional-topics',
          element: <OptionalTopicsPage />,
        },
        {
          path: '/tutoring-classes',
          element: <TutoringClassesPage />,
        },
        {
          path: '/tutoring-classes/new',
          element: <TutoringClassFormPage />,
        },
        {
          path: '/tutoring-classes/:id',
          element: <TutoringClassFormPage />,
        },
        {
          path: '/registers',
          element: <ClassRegisterPage />,
        },
        {
          path: '/reports',
          element: <ReportsPage />,
        },
        {
          path: '/tutor-payouts',
          element: <TutorPayoutsPage />,
        },
        {
          path: '/waiting-list',
          element: <WaitingListPage />,
        },
        {
          path: '/inbox',
          element: <MessagingPage />,
        },
        {
          path: '/cover-requests',
          element: <CoverRequestsPage />,
        },
        {
          path: '/renewals',
          element: <RenewalsPage />,
        },
        {
          path: '/contact-enquiries',
          element: <ContactEnquiriesPage />,
        },
        {
          path: '/contact-enquiries/:id',
          element: <ContactEnquiryDetailPage />,
        },
        {
          path: '/consultations',
          element: <ConsultationSlotsPage />,
        },
      ],
    },

    {
      path: '/login',
      element: token ? <Navigate to="/class" /> : <LoginPage />,
    },
    {
      path: '/register',
      element: <RegisterPage />,
    },
    {
      element: <Dashboard />,
      children: [
        { element: <Navigate to="/class" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },

    // {
    //   children: [
    //     { element: <Navigate to="/user" />, index: true },
    //     { path: '404', element: <Page404 /> },
    //     { path: '*', element: <Navigate to="/404" /> },
    //   ],
    // },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
